// API configuration
// Using computer's local IP for mobile testing
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8086';

// Other global configuration settings
export const APP_NAME = 'FieldFlow';
export const APP_VERSION = '1.0.0';
